'use strict';

var React = require('react');
var useProps = require('../html/use-props.cjs');
var buildAttrs = require('./utils/build-attrs.cjs');
var createRenderState = require('./utils/create-render-state.cjs');
var isSvgTag = require('./utils/is-svg-tag.cjs');

function useSVGProps(props, visualState, _isStatic, Component) {
    const visualProps = React.useMemo(() => {
        const state = createRenderState.createSvgRenderState();
        buildAttrs.buildSVGAttrs(state, visualState, isSvgTag.isSVGTag(Component), props.transformTemplate, props.style);
        return {
            ...state.attrs,
            style: { ...state.style },
        };
    }, [visualState]);
    if (props.style) {
        const rawStyles = {};
        useProps.copyRawValuesOnly(rawStyles, props.style, props);
        visualProps.style = { ...rawStyles, ...visualProps.style };
    }
    return visualProps;
}

exports.useSVGProps = useSVGProps;
//# sourceMappingURL=use-props.cjs.map
